<div id="report" class="container-fluid pt-3">
    <mat-toolbar class="one-header">
        <mat-toolbar-row class="header-row">
            <h2 class="title">Báo cáo</h2>
            <div class="one-spacer"></div>
        </mat-toolbar-row>
        <mat-toolbar-row class="header-row overflow-x">
            <nav mat-tab-nav-bar class="one-tab-nav-bar">
                <a mat-tab-link class="one-tab" [active]="isGeneral" (click)="reportGeneral()">Tổng quan</a>
                <a mat-tab-link class="one-tab" [active]="isGroup" (click)="reportByGroup()">Báo cáo theo nhóm</a>
            </nav>
            <div class="right-side">
                <mat-form-field appearance="fill" *ngIf="isGroup">
                    <mat-label>Nhóm đề xuất</mat-label>
                    <mat-select [formControl]="requestGroupForm">
                        <mat-option [value]="requestGroup.id" *ngFor="let requestGroup of requestGroups">
                            {{ requestGroup.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="date-range">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="picker">
                        <input matStartDate formControlName="start" placeholder="Start date">
                        <input matEndDate formControlName="end" placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <div class="pinner-bkg" *ngIf="loading">
        <div class="pinner">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <mat-accordion multi *ngIf="!loading">
        <general-report [generalReportData]="generalReportData" [users]="users"></general-report>
        <request-report [generalReportData]="generalReportData" [actionReportData]="actionReportData"></request-report>
        <!-- <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h3 class="title">{{text.REPORT.GROUP}}</h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
        </mat-expansion-panel>

        <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h3 class="title">{{text.REPORT.USER}}</h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
        </mat-expansion-panel> -->
    </mat-accordion>
</div>